<div class="p-2 flex justify-between items-center">
  <div class="text-center">{{ countChecked }} / {{ maxBatchSize }}</div>

  <button
    (click)="cancelSelection.emit()"
    [disabled]="countChecked === 0 || disabled"
    [title]="'catalog.multi_image_download.cancel_selection' | transloco"
    mat-icon-button
    class="error-icon-button"
    >
    <mat-icon>delete</mat-icon>
  </button>
</div>

<div class="py-2">
  <div class="flex justify-center flex-wrap">
    @for (item of checked; track item) {
      <div (click)="selectChange.emit(item)" class="cursor-pointer relative mr-1 mb-1">
        <div
        [ngClass]="[
          selected?.id === item.id ? 'block' : 'hidden',
          'active-panel top-0 bottom-0 left-0 right-0 absolute'
        ]"
        ></div>
        <img [src]="item.image | safe" class="h-64"/>
      </div>
    }
  </div>
</div>
